<template>
  <div class="page-wrap">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
      <el-breadcrumb-item class="linkpath">服务报告</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <section class="content-warpper data-table">
        <el-row type="flex" justify="space-between">
          <el-col :span="5" class="f16 nowrap" >
						<el-button type="primary" size="small" style="margin:0 20px 0 0;" @click="linkCreateReport" v-if="type.logintype == 'KEFU'">生成服务报告</el-button>
            <span v-if="type.logintype == 'KEFU'">品牌方绑定人员:{{userInfo.nickname || '未绑定'}}</span>
          </el-col>
          <el-col :span="2">
            <el-popover
              v-if="!userInfo.nickname"
              placement="bottom"
              popper-class="alignCenter"
              width="178"
              style="height:178px"
              trigger="click"
            >
              <el-image :src="wechatUrl"></el-image>
              <p>扫码绑定</p>
              <span class="btn-icon" slot="reference" @click="clickBind()"  v-if="type.logintype == 'KEFU'">点击绑定</span>
            </el-popover>
          </el-col>
          <el-col :span="16" style="text-align:right;">
            <div class="input-wraper">
              <span style="font-size: 14px;">报告生成时间:</span>&nbsp;
              <el-date-picker
                v-model="reportDate"
                value-format="yyyy-MM-dd"
                size="small"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                range-separator="~"
                :picker-options="pickerOptions"
                @change="timeChange"
              ></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <!-- 提示 -->
        <div class="table-notice" v-if="type.logintype == 'KEFU'">
          <span class="trumpet_icon" style="margin-left: 10px;"></span>
          建议截取二维码图片，邀请品牌方负责人绑定微信，成功绑定微信后，服务报告可通过微信推送。
        </div>
        <!-- 表格 -->
        <el-table
          header-row-class-name="data-table-header"
          :data="serviceReportData.content"
          tooltip-effect="dark"
          style="width: 100%;margin-top: 10px;"
          @row-click="linkDetail"
        >
          <!-- 序号列 -->
          <el-table-column label="序号" fixed="left" type="index" width="50"></el-table-column>
          <el-table-column
            v-for="(colItem,i) in columsData"
            :key="i"
            :prop="colItem.prop"
            :label="colItem.label"
            min-width="120"
          >
            <template slot-scope="scope">
              <span v-if="colItem.prop === 'createtime'">{{scope.row.createtime|fullTime}}</span>
              <span v-else>{{scope.row[colItem.prop]}}</span>
            </template>
          </el-table-column>
          <!-- 操作列 -->
          <el-table-column label="操作" fixed="right" width="200" class-name="operate" v-if="type.logintype == 'KEFU'">
            <template slot-scope="scope">
              <span class="op-btn delete" @click.stop="handleDelete(scope.row)">
                <i class="el-icon-delete"></i>删除
              </span>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-if="serviceReportData.totalElements"
          class="pagination"
          :total="serviceReportData.totalElements"
          v-model="pagination"
          @onChange="load"
        />
      </section>
    </div>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import Pagination from "@/components/pagination/pagination";
import { getSinceThreeMonth } from "@/libs/date";
import {fetchPost} from "@/libs/reqCommon";
import {renderDialog } from "@/libs/renderCommon.js"
import { mapState, mapActions } from "vuex";
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
let titles = [
  { label: "报告名称", prop: "channelname" },
  { label: "服务数据范围", prop: "servicescope" },
  { label: "生成客服", prop: "username" },
  { label: "报告生成时间 ", prop: "createtime" }
];
export default {
  components: { Pagination,wxBindingComponent },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, start]);
            }
          },{
            text: '近7日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '近15日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '近30日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: "近90日",
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '近365日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      type: '',
      wechatUrl: "",
      reportDate: [],
      columsData: titles,
      pagination: {
        size: 10,
        current: 1
      }
    };
  },
  computed: {
    ...mapState({
      serviceReportData: state => state.serviceReport.serviceReportData,
      userInfo: state => state.serviceReport.userinfo
    })
  },
  created() {
    this.type = JSON.parse(window.localStorage.userData);
    console.log(this.type.logintype)
    this.reqGetbmcwx();
    this.load();
  },
  methods: {
    ...mapActions([ "reqGetbmcwx", "reqServiceReportList"]),
    timeChange(date) {
      if (!date) {
        let params = {
          pageNo: 1,
          pageSize: this.pagination.size
        };
        this.reqServiceReportList(params);
        return false;
      }
      this.reportDate[0] = date[0];
      this.reportDate[1] = date[1];
      this.load();
    },
    // 删除请求
    reqDelete(query,url){
      fetchPost(url, query).then(res => {
        if(res.status == '10000'){
          this.$message({
            message: '操作成功！',
            type: res.message
          })
          this.load();
        }else{
          this.$message.error(res.message);
        }
      })
    },
		//删除
		handleDelete(row){
			let query = {
				id:row.id
      }
      let url = "hcm//hcmChannelServiceReport/delectchannelServiceReport"
      let func = this.reqDelete
      let info = {
        title:`你确认要删除该服务报告吗?`,
        infoccc:'删除后',infored:`报告将无法恢复`
      }
      renderDialog(info,url,query,func,this)
		},
    getParams() {
      let params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.size,
        begintime: this.reportDate[0],
        endtime: this.reportDate[1]
      };
      return params;
    },
    load() {
      let params = this.getParams();
      this.reqServiceReportList(params);
    },
    // 点击绑定
    clickBind() {
      this.$refs.childWxBinding.getbmcwx('c',this.userInfo.id,this.userInfo.openid)
		},
		// 列表到服务报告详情
		linkDetail(row) {
      let query = {
        id: row.id,
        bmcid: row.bmcid,
        // servicescope: row.servicescope,
				url: decodeURIComponent(row.channelurl),
				startTime:row.servicescope.substring(0, 10),
				endTime:row.servicescope.substring(11),
			};
			this.$store.commit('createQuery', query);
			this.$store.commit('changeStep',{})
      this.$router.push({ path: "/reportDetail",query});
    },
		linkCreateReport(){
			this.$store.commit('changeStep',{step:0,stepText:'第一步'});
			this.$router.push({path:'/createReportStep'})
		}
  }
};
</script>

<style lang="scss">

@import "src/style/dataTable";
$highColor: #108cee;
.el-table__body tr.hover-row {
  cursor: default !important;
}
.f16 {
  font-size: 16px;
}
.nowrap{
	white-space: nowrap;
}
.alignCenter {
  text-align: center;
}
.btn-icon {
  font-size: 16px;
  color: $highColor;
  cursor: pointer;
}
.info-modal {
  .el-icon-warning {
    color: #f9bb63;
    font-size: 24px;
    line-height: 70px;
    &.cas {
      line-height: 50px;
    }
  }
  .content {
    width: calc(100% - 40px);
    float: right;
  }
  .red {
    color: red;
    margin: 0 0 10px 0;
  }
}
.table-notice {
  color: #faad14;
  font-size: 12px;
  background: #fffbf3;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  .trumpet_icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: url("../../../assets/img/other/trumpet_icon.png") no-repeat;
    background-position: center;
    vertical-align: sub;
  }
}
.pagination {
  text-align: right;
  margin: 10px 0;
}
</style>
